import { render, staticRenderFns } from "./ShowRandomPlayer.vue?vue&type=template&id=000869d4&scoped=true&"
import script from "./ShowRandomPlayer.vue?vue&type=script&lang=js&"
export * from "./ShowRandomPlayer.vue?vue&type=script&lang=js&"
import style0 from "./ShowRandomPlayer.vue?vue&type=style&index=0&id=000869d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000869d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VDialog,VRow})
